<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <ErroSistema :type="error.type" :message="error.message" :status="error.status" ref="erroDialog"/>

        <v-dialog v-model="dialogPlotagemViagem" fullscreen>
            <v-card>
                <v-toolbar color="primary">
                <v-toolbar-title>
                    <div class="headline" style="color: white">Relatório de Plotagem da Viagem</div>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="closePlotagemViagem" dark>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-toolbar>
            <v-card-text>
                <RELPlotagem :key="plotagemKey" :viagem="selectedViagem"/>
            </v-card-text>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="mapDialog" max-width="80%">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeMapDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ mapDialogTitle }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div id="mapcontainer" style="margin-top: 10px;">
              <l-map ref="map" :zoom="zoom" :center="currentCenter" :options="mapOptions" @ready="onMapReady" @resize="onMapResize" :key="mapKey">
                <l-tile-layer :url="url" :attribution="attribution" />

                <l-marker :lat-lng="latLng(marker.lat, marker.lng)">
                  <l-tooltip :content="marker.tooltip" :options="{permanent: true, direction: 'top', opacity: 1.0}"></l-tooltip>
                </l-marker>
              </l-map>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
                <v-col cols="12">
                    <div class="headline">{{$t('RELHistoricoVeiculo.title')}}</div>
                </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                  v-model="idEmpresaSelected"
                  :items="empresas"
                  item-text="razao_social"
                  item-value="id_empresa"
                  clearable
                  :label="$tc('company.self', 1)"
                ></v-autocomplete>
              </v-col>
              <!-- adicionar unidade -->
              <v-col cols="12" sm="6" md="3">
                <MultiplaEscolha 
                  :items="unidadesItens"
                  v-bind:selected-items.sync="unidadesSelecionadas"
                  text="descricao_unidade"
                  value="id_unidade"
                  :label="$t('nav.registration.units')"
                  :max-items="2"
                />
              </v-col>
              <!-- termina unidade -->
              <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  :label="$t('datetime.startDate')"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :date-picker-props="dtiProps"
                  :text-field-props="textFieldProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  :clear-text="$t('datetime.close')"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('datetime.finalDate')"
                v-model="dtf"
                :time-picker-props="timeProps"
                :date-picker-props="dtfProps"
                :text-field-props="textFieldProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                    v-model="idVeiculosSelected"
                    :items="veiculosSelect"
                    item-text="numero_ordem"
                    item-value="id_veiculo"
                    clearable
                    :label="$tc('vehicle.self', 1)"
                    :rules="[(v) => (!!v) || $t('vehicle.rules.select')]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="1" align="end">
              <div style="display: flex; justify-content: flex-end; gap: 10px;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      fab
                      color="primary darken-1"
                      class="white--text"
                      v-bind="attrs"
                      v-on="on"
                      @click="populaRelatorio"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('operation.search') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      fab
                      color="primary darken-1"
                      class="white--text"
                      v-bind="attrs"
                      v-on="on"
                      @click="setDefaultFilters"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('operation.newConsult') }}</span>
                </v-tooltip>
              </div>
            </v-col>
            </v-row>
          </v-form>
        </v-container>

        <!-- Timeline de Posições -->
        <v-container class="timeline-container">
            <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
            <div v-if="posicoes.length > 0 && !loading" class="timeline-wrapper">
                <v-row>
                    <v-col cols="12">
                        <div class="headline mb-4">{{ $t('RELHistoricoVeiculo.timeline.title') }}</div>
                    </v-col>
                </v-row>
                
                <!-- Timeline -->
                <div class="timeline-container-inner">
                    <!-- Escala de tempo -->
                    <div class="time-scale">
                        <div 
                            v-for="point in timeScalePoints" 
                            :key="point.position"
                            class="time-marker"
                            :style="{ left: point.position + '%' }"
                        >
                            <div class="time-label">{{ formatTime(point.time) }}</div>
                            <div class="time-line"></div>
                        </div>
                    </div>
                    
                    <!-- Timeline principal -->
                    <div class="timeline-main">
                        <div class="timeline-track">
                            <div 
                                v-for="(segment, index) in timelineSegments" 
                                :key="index"
                                class="timeline-segment"
                                :class="[
                                    'segment-' + segment.type,
                                    { 'has-position': segment.hasPosition }
                                ]"
                                :style="{ 
                                    left: segment.left + '%', 
                                    width: segment.width + '%' 
                                }"
                                :title="segment.tooltip"
                                @click="segment.hasPosition && onSegmentClick(segment)"
                            >
                                <div v-if="segment.hasPosition" class="segment-content">
                                    <div class="segment-indicator"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Legenda -->
                    <div class="timeline-legend">
                        <div class="legend-item">
                            <div class="legend-color green"></div>
                            <span>{{ $t('RELHistoricoVeiculo.timeline.legend.ok') }}</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color red"></div>
                            <span>{{ $t('RELHistoricoVeiculo.timeline.legend.invalid') }}</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color yellow"></div>
                            <span>{{ $t('RELHistoricoVeiculo.timeline.legend.delayed') }}</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-color gray"></div>
                            <span>{{ $t('RELHistoricoVeiculo.timeline.legend.noPosition') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </v-container>

        <!-- Tabs para as tabelas -->
        <v-card class="tabs-container">
            <v-tabs v-model="activeTab" background-color="primary" dark>
                <v-tab>
                    <v-icon left>mdi-file-document-outline</v-icon>
                    {{ $t('RELHistoricoVeiculo.tabs.guides') }}
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-bus</v-icon>
                    {{ $t('RELHistoricoVeiculo.tabs.realizedTrips') }}
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-credit-card</v-icon>
                    {{ $t('RELHistoricoVeiculo.tabs.bilhetagens') }}
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-bell</v-icon>
                    {{ $t('RELHistoricoVeiculo.tabs.notifications') }}
                </v-tab>
            </v-tabs>

            <v-card-text>
            <v-tabs-items v-model="activeTab">
                <!-- Tab Guias -->
                <v-tab-item>
                    <merus-data-table
                        :headers="tableHeadersGuias"
                        :items="guias"
                        :loading="loadingGuias"
                        :default-multi-sort="defaultMultiSortGuias"
                        :loading-text="$t('system.messages.loading')"
                        @update:displayedItems="displayedItemsForExportGuias = $event"
                    

 cod-tabela="RELHISTORICOVEICULO__GUIAS" @update:headers="headersGuias = $event">
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="$t('RELHistoricoVeiculo.tabs.guides')"
                            :items="displayedItemsForExportGuias !== null ? displayedItemsForExportGuias : guias"
                            :token="token"
                            :user="user.id_usuario"
                            csv-title="guiashistorico"
                            :csv-headers="tableHeadersGuias"
                            pdf-title="Histórico de Veículo - Guias"
                            :pdf-headers="tableHeadersGuias"
                            pdf-filename="guiashistorico"
                            hide-search
                        ></CadastroToolbar>
                    </template>
                </merus-data-table>
                </v-tab-item>

                <!-- Tab Viagens Realizadas -->
                <v-tab-item>
                    <merus-data-table
                        :headers="tableHeadersViagens"
                        :items="viagens"
                        :loading="loadingViagens"
                        :default-multi-sort="defaultMultiSortViagens"
                        :loading-text="$t('system.messages.loading')"
                        @update:displayedItems="displayedItemsForExportViagens = $event"
                    

 cod-tabela="RELHISTORICOVEICULO__VIAGENS" @update:headers="headersViagens = $event">
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="$t('RELHistoricoVeiculo.tabs.realizedTrips')"
                            :items="displayedItemsForExportViagens !== null ? displayedItemsForExportViagens : viagens"
                            :token="token"
                            :user="user.id_usuario"
                            csv-title="viagenshistorico"
                            :csv-headers="tableHeadersViagens"
                            pdf-title="Histórico de Veículo - Viagens Realizadas"
                            :pdf-headers="tableHeadersViagens"
                            pdf-filename="viagenshistorico"
                            hide-search
                        ></CadastroToolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="openPlotagemViagem(item)" small color="blue" dark>mdi-map-marker</v-icon>
                    </template>
                </merus-data-table>
                </v-tab-item>

                <!-- Tab Bilhetagens -->
                <v-tab-item>
                    <merus-data-table
                        :headers="tableHeadersBilhetagens"
                        :items="bilhetagens"
                        :loading="loadingBilhetagens"
                        :default-multi-sort="defaultMultiSortBilhetagens"
                        :loading-text="$t('system.messages.loading')"
                        @update:displayedItems="displayedItemsForExportBilhetagens = $event"
                    

 cod-tabela="RELHISTORICOVEICULO__BILHETAGENS" @update:headers="headersBilhetagens = $event">
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="$t('RELHistoricoVeiculo.tabs.bilhetagens')"
                            :items="displayedItemsForExportBilhetagens !== null ? displayedItemsForExportBilhetagens : bilhetagens"
                            :token="token"
                            :user="user.id_usuario"
                            csv-title="bilhetagenshistorico"
                            :csv-headers="tableHeadersBilhetagens"
                            pdf-title="Histórico de Veículo - Bilhetagens"
                            :pdf-headers="tableHeadersBilhetagens"
                            pdf-filename="bilhetagenshistorico"
                            hide-search
                        ></CadastroToolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="plotar(item, 'Bilhetagem')" small color="blue" dark>mdi-map-marker</v-icon>
                    </template>

                    <template v-slot:item.valor_pago="{ item }">
                        {{ item.valor_pago ? Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor_pago) : '' }}
                    </template>
                </merus-data-table>
                </v-tab-item>

                <!-- Tab Notificações -->
                <v-tab-item>
                    <merus-data-table
                        :headers="tableHeadersNotificacoes"
                        :items="notificacoes"
                        :loading="loadingNotificacoes"
                        :default-multi-sort="defaultMultiSortNotificacoes"
                        :loading-text="$t('system.messages.loading')"
                        @update:displayedItems="displayedItemsForExportNotificacoes = $event"
                    

 cod-tabela="RELHISTORICOVEICULO__NOTIFICACOES" @update:headers="headersNotificacoes = $event">
                    <template v-slot:toolbar>
                        <CadastroToolbar
                            :title="$t('RELHistoricoVeiculo.tabs.notifications')"
                            :items="displayedItemsForExportNotificacoes !== null ? displayedItemsForExportNotificacoes : notificacoes"
                            :token="token"
                            :user="user.id_usuario"
                            csv-title="notificacoeshistorico"
                            :csv-headers="tableHeadersNotificacoes"
                            pdf-title="Histórico de Veículo - Notificações"
                            :pdf-headers="tableHeadersNotificacoes"
                            pdf-filename="notificacoeshistorico"
                            hide-search
                        ></CadastroToolbar>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="plotar(item, 'Notificação')" small color="blue" dark>mdi-map-marker</v-icon>
                    </template>
                </merus-data-table>
                </v-tab-item>
            </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
// import VueJsonToCsv from "vue-json-to-csv";
// import ExportTablePdf from "./ExportTablePdf.vue";
import DateUtils from "../utils/dateutils";
import ErroSistema from "./Notifications/ErroSistema.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import L from "leaflet";
import translateDbField from "@/utils/translateDbField";
import {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import RELPlotagem from "./RELPlotagem.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
    components: {
        // VueJsonToCsv,
        // ExportTablePdf,
        ErroSistema,
        MerusDataTable,
        CadastroToolbar,
        LMap,
        LTileLayer,
        LMarker,
        LTooltip,
        RELPlotagem,
        MultiplaEscolha
    },
    data: () => ({
    headersNotificacoes: [],
    headersBilhetagens: [],
    headersViagens: [],
    headersGuias: [],
        user: null,
        token: null,
        activeTab: 0,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapDialog: false,
        mapKey: 0,
        zoom: 12,
        currentCenter: null,
        mapOptions: {
            zoomSnap: 0.5,
        },
        marker: {
            lat: null,
            lng: null,
            tooltip: "",
            type: ""
        },
        error: {
            type: "",
            message: "",
            status: null,
        },
        loading: false,
        empresas: [],
        idEmpresaSelected: null,
        unidades: [],
        unidadesSelecionadas: [],
        veiculos: [],
        idVeiculosSelected: null,
        historico: [],
        posicoes: [],
        config: null,
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        formValidado: false,
        guias: [],
        displayedItemsForExportGuias: null,
        loadingGuias: false,
        viagens: [],
        displayedItemsForExportViagens: null,
        loadingViagens: false,
        bilhetagens: [],
        displayedItemsForExportBilhetagens: null,
        loadingBilhetagens: false,
        notificacoes: [],
        displayedItemsForExportNotificacoes: null,
        loadingNotificacoes: false,
        dialogPlotagemViagem: false,
        plotagemKey: 0,
        selectedViagem: {
            id_empresa: null,
            id_veiculo_realizado: null,
            horario_saida_prevista: null,
            horario_chegada_prevista: null
        },
    }),
    computed: {
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        defaultMultiSortBilhetagens() {
            return [
            { value: "dt_posicao", options: { text: this.$t('system.labels.increasing'), value: 1 } }];

        },
        defaultHeadersBilhetagens() {
            return [
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.idBilhetagem'), value: "id_bilhetagem", align: " d-none", show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.dateTime'), value: "dt_posicao", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.dateTime'), value: "dt_posicao_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.application'), value: "descricao_aplicacao", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.applicationType'), value: "descricao_tipo_aplicacao", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.issuer'), value: "descricao_emissor", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.paidValue'), value: "valor_pago", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerBilhetagens.actions'), value: "actions", sortable: false, filtrable: false, show: true },
            ];
        },
        tableHeadersBilhetagens() {
            return this.headersBilhetagens.length > 0 ? this.headersBilhetagens : this.defaultHeadersBilhetagens;
        },
        textFieldProps() {
            return {
            prependInnerIcon: "mdi-calendar",
            rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            };
        },
        defaultMultiSortGuias() {
            return [
            { value: "dt_pegada", options: { text: this.$t('system.labels.increasing'), value: 1 } }];

        },
        defaultHeadersGuias() {
            return [
                { text: this.$t('RELHistoricoVeiculo.headerGuides.idGuide'), value: "id_guia", align: " d-none", sortable: false, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.guide'), value: "guia_original", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.line'), value: "cod_linha", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.vehicle'), value: "cod_veiculo", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.driver'), value: "matricula_motorista", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.driverName'), value: "nome_motorista", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.collector'), value: "matricula_cobrador", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.collectorName'), value: "nome_cobrador", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.dtPicked'), value: "dt_pegada", align: " d-none", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.picked'), value: "dt_pegada_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.departure'), value: "dt_largada_extenso", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.shift'), value: "turno", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.escalation'), value: "escalonamento", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.opening'), value: "dt_abertura_erp_extenso", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerGuides.closing'), value: "dt_fechamento_erp_extenso", sortable: true, filtrable: true, show: true },
            ];
        },
        tableHeadersGuias() {
            return this.headersGuias.length > 0 ? this.headersGuias : this.defaultHeadersGuias;
        },
        defaultMultiSortViagens() {
            return [
            { value: "horario_saida_realizada", options: { text: this.$t('system.labels.increasing'), value: 1 } }];

        },
        defaultHeadersViagens() {
            return [
                { text: this.$t('RELHistoricoVeiculo.headerViagens.idTrip'), value: "id_viagem_grid", align: " d-none", show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.line'), value: "cod_linha", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.guide'), value: "numero_guia_realizada", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.scheduledDeparture'), value: "horario_saida_prevista", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.scheduledDeparture'), value: "horario_saida_prevista_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.actualDeparture'), value: "horario_saida_realizada", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.actualDeparture'), value: "horario_saida_realizada_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.scheduledArrival'), value: "horario_chegada_prevista", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.scheduledArrival'), value: "horario_chegada_prevista_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.actualArrival'), value: "horario_chegada_realizada", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.actualArrival'), value: "horario_chegada_realizada_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.direction'), value: "descricao_sentido", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.shift'), value: "descricao_turno", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.passengers'), value: "passageiros_totais", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.vehicleEscalation'), value: "escalonamento_veiculo", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.tripEscalation'), value: "escalonamento_viagem", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.opening'), value: "abertura", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.closing'), value: "fechamento", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.dtOpening'), value: "dt_abertura_manual_extenso", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.dtClosing'), value: "dt_fechamento_manual_extenso", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerViagens.actions'), value: "actions", sortable: false, filtrable: false, show: true },
            ];
        },
        tableHeadersViagens() {
            return this.headersViagens.length > 0 ? this.headersViagens : this.defaultHeadersViagens;
        },
        defaultMultiSortNotificacoes() {
            return [
            { value: "hierarquia_notificacao", options: { text: this.$t('system.labels.increasing'), value: 1 } },
            { value: "dt_notificacao", options: { text: this.$t('system.labels.decreasing'), value: -1 } }];

        },
        defaultHeadersNotificacoes() {
            return [
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.idNotification'), value: "id_notificacao", align: " d-none", show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.hierarchy'), value: "hierarquia_notificacao", align: " d-none", filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.dateTime'), value: "dt_notificacao", align: " d-none", sortable: true, filtrable: false, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.dateTime'), value: "dt_notificacao_extenso", sortable: false, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.notificationType'), value: "descricao_tipo_notificacao", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.line'), value: "cod_linha", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.treated'), value: "reset_extenso", sortable: true, filtrable: true, show: true },
                { text: this.$t('RELHistoricoVeiculo.headerNotifications.actions'), value: "actions", sortable: false, filtrable: false, show: true },
            ];
        },
        tableHeadersNotificacoes() {
            return this.headersNotificacoes.length > 0 ? this.headersNotificacoes : this.defaultHeadersNotificacoes;
        },
        veiculosSelect() {
            let veiculosFiltrados = this.veiculos.filter((v) => v.id_empresa == this.idEmpresaSelected);
            veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
            return veiculosFiltrados;
        },
        unidadesItens() {
            return this.unidades;
        },
        today() {
        return new Date().toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.today,
          rules: [this.dtRules]
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min,
          rules: [this.dtRules]
        }
      },
      dtRules() {
        return () => true;
      },
      dateDiff() {
        let start = typeof this.dti === "string" ? 
          new Date(this.dti.substring(6,10), this.dti.substring(3,5) - 1, this.dti.substring(0,2), this.dti.substring(11,13), this.dti.substring(14,16), this.dti.substring(17,19)) :
          this.dti;
        let end = typeof this.dtf === "string" ? 
          new Date(this.dtf.substring(6,10), this.dtf.substring(3,5) - 1, this.dtf.substring(0,2), this.dtf.substring(11,13), this.dtf.substring(14,16), this.dtf.substring(17,19)) :
          this.dtf;

        return (end - start) / 3600000;
      },
      timelineSegments() {
        if (!this.posicoes || this.posicoes.length === 0 || !this.dti || !this.dtf) return [];

        const segments = [];
        const dtiMs = this.dti.getTime();
        const dtfMs = this.dtf.getTime();
        const totalDurationMs = dtfMs - dtiMs;
        if (totalDurationMs <= 0) return [];

        const maxSegments = 500;
        const segmentDurationMs = Math.max(30 * 1000, Math.ceil(totalDurationMs / maxSegments));
        const totalSegments = Math.ceil(totalDurationMs / segmentDurationMs);

        const posicoesOrdenadas = this.posicoes
          .map((pos) => ({
            pos,
            timeMs: new Date(pos.dt_posicao).getTime(),
          }))
          .sort((a, b) => a.timeMs - b.timeMs);

        let posicaoIndex = 0;

        for (let i = 0; i < totalSegments; i++) {
          const segmentStartMs = dtiMs + (i * segmentDurationMs);
          const segmentEndMs = Math.min(segmentStartMs + segmentDurationMs, dtfMs);
          const segmentStart = new Date(segmentStartMs);
          const segmentEnd = new Date(segmentEndMs);

          const segmentStartOffset = segmentStartMs - dtiMs;
          const segmentDuration = segmentEndMs - segmentStartMs;
          const leftPosition = (segmentStartOffset / totalDurationMs) * 100;
          const width = (segmentDuration / totalDurationMs) * 100;

          while (
            posicaoIndex < posicoesOrdenadas.length &&
            posicoesOrdenadas[posicaoIndex].timeMs < segmentStartMs
          ) {
            posicaoIndex += 1;
          }

          const positionEntry = posicaoIndex < posicoesOrdenadas.length &&
            posicoesOrdenadas[posicaoIndex].timeMs < segmentEndMs
            ? posicoesOrdenadas[posicaoIndex]
            : null;

          if (positionEntry) {
            const position = positionEntry.pos;
            segments.push({
              startTime: segmentStart,
              endTime: segmentEnd,
              hasPosition: true,
              type: this.getPositionType(position),
              left: leftPosition,
              width: width,
              tooltip: this.getPositionTooltip(position, segmentStart),
              position: position,
            });
          } else {
            segments.push({
              startTime: segmentStart,
              endTime: segmentEnd,
              hasPosition: false,
              type: 'gray',
              left: leftPosition,
              width: width,
              tooltip: this.$t('RELHistoricoVeiculo.noPositionBetween') + " " + this.formatTime(segmentStart) + " " + this.$t('RELHistoricoVeiculo.and') + " " + this.formatTime(segmentEnd),
              missingDuration: this.formatDuration(segmentDuration / 60000),
            });
          }
        }

        return segments;
      },
      timeScalePoints() {
        if (!this.dti || !this.dtf) return [];
        
        const totalDurationMs = this.dtf.getTime() - this.dti.getTime(); // em milissegundos
        const totalDurationMinutes = totalDurationMs / (1000 * 60); // em minutos
        const numPoints = Math.min(8, Math.max(3, Math.floor(totalDurationMinutes / 30))); // Entre 3 e 8 pontos
        const points = [];
        
        for (let i = 0; i <= numPoints; i++) {
          const timeOffsetMs = (i / numPoints) * totalDurationMs; // em milissegundos
          const time = new Date(this.dti.getTime() + timeOffsetMs);
          const position = (i / numPoints) * 100;
          
          points.push({
            time: time,
            position: position
          });
        }
        
        return points;
      },
      mapDialogTitle() {
        return this.marker.type || this.$t('RELHistoricoVeiculo.map');
      }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {

        idsUnidadesNoObjeto(o) {
            if (Array.isArray(o.unidades) && o.unidades.length) {
                return o.unidades.map((id) => Number(id));
            }
            if (o.id_unidade != null && o.id_unidade !== "") {
                return [Number(o.id_unidade)];
            }
            return [];
        },
        passaFiltroUnidades(o) {
            if (this.unidadesSelecionadas.length === 0) {
                return true;
            }
            const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
            return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
        },
        async initialize() {
            this.currentCenter = this.center;
            this.config = await this.populaConfig();
            [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
            this.empresas = await this.populaEmpresas();
            this.veiculos = await this.populaVeiculos();
            await this.populaUnidades();
        },
        async populaConfig() {
            const response = await apiController.request(apiController.endpoints.getallConfig, { silent: true });

            if (response.status !== 200 || response.data.erro) {
                this.error.type = "API";
                this.error.message = response.data.mensagem;
                this.error.status = response.status;
                this.$refs.erroDialog.showError();
                return null;
            }

            return response.data[0];
        },
        async populaEmpresas() {
            const response = await apiController.request(apiController.endpoints.getallEmpresas, { silent: true });

            if (response.status !== 200 || response.data.erro) {
                this.error.type = "API";
                this.error.message = response.data.mensagem;
                this.error.status = response.status;
                this.$refs.erroDialog.showError();
                return [];
            }

            return response.data;
        },
        async populaVeiculos() {
            const response = await apiController.request(apiController.endpoints.getallVeiculosativos, { silent: true });

            if (response.status !== 200 || response.data.erro) {
                this.error.type = "API";
                this.error.message = response.data.mensagem;
                this.error.status = response.status;
                this.$refs.erroDialog.showError();
                return [];
            }

            return response.data || [];
        },
        async populaUnidades() {
            try {
                const response = await apiController.request(apiController.endpoints.getallUnidadesativas, { silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return;
                }

                this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
            } catch (error) {
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('RELHistoricoVeiculo.errorLoadingUnits');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
            }
        },
        setDefaultFilters() {
            this.posicoes = [];
            this.guias = [];
            this.viagens = [];
            this.bilhetagens = [];
            this.notificacoes = [];
            [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
            this.idEmpresaSelected = null;
            this.idVeiculosSelected = null;
        },
        async populaRelatorio() {
            this.$refs.form.validate();
            if (this.formValidado) {
                this.posicoes = await this.populaPosicoes();
                this.guias = await this.populaGuias();
                this.viagens = await this.populaViagens();
                this.bilhetagens = await this.populaBilhetagens();
                this.notificacoes = await this.populaNotificacoes();
            }
        },
        async populaPosicoes() {
            this.loading = true;
            try {
                const payload = {
                    id: this.idVeiculosSelected,
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                };

                const response = await apiController.request(apiController.endpoints.getPosicoesporcarrodata, { data: payload, silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return [];
                }

                return response.data;
            } catch (error) {
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('system.messages.nonIdentifiedSystemError');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
                return [];
            } finally {
                this.loading = false;
            }
        },
        async populaGuias() {
            this.loadingGuias = true;
            try {
                const payload = {
                    idveiculo: this.idVeiculosSelected,
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                };

                const response = await apiController.request(apiController.endpoints.getGuiasveiculodata, { data: payload, silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return [];
                }

                return response.data;
            } catch (error) {
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('system.messages.nonIdentifiedSystemError');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
                return [];
            } finally {
                this.loadingGuias = false;
            }
        },
        async populaViagens() {
            this.loadingViagens = true;
            try {
                const payload = {
                    idveiculo: this.idVeiculosSelected,
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                };

                const response = await apiController.request(apiController.endpoints.getViagensgridveiculodata, { data: payload, silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return [];
                }

                return response.data;
            } catch (error) {
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('system.messages.nonIdentifiedSystemError');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
                return [];
            } finally {
                this.loadingViagens = false;
            }
        },
        async populaBilhetagens() {
            this.loadingBilhetagens = true;
            try {
                const payload = {
                    id: [this.idVeiculosSelected],
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                };

                const response = await apiController.request(apiController.endpoints.getBilhetagensporcarrodata, { data: payload, silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return [];
                }

                return response.data;
            } catch (error) {
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('system.messages.nonIdentifiedSystemError');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
                return [];
            } finally {
                this.loadingBilhetagens = false;
            }
        },
        async populaNotificacoes() {
            this.loadingNotificacoes = true;
            const dti = DateUtils.getDateSQLFormatted(this.dti);
            const dtf = DateUtils.getDateSQLFormatted(this.dtf);
            const idveiculo = this.idVeiculosSelected;

            try {
                const response = await apiController.request(apiController.endpoints.getNotificacoesveiculopordata, { params: { dti, dtf, idveiculo }, silent: true });

                if (response.status !== 200 || response.data.erro) {
                    this.loadingNotificacoes = false;
                    this.error.type = "API";
                    this.error.message = response.data.mensagem;
                    this.error.status = response.status;
                    this.$refs.erroDialog.showError();
                    return [];
                }

                this.loadingNotificacoes = false;
                return response.data.map((n) => ({
                    ...n,
                    descricao_tipo_notificacao: translateDbField(
                        n.translation_key, 
                        n.descricao_tipo_notificacao
                    )
                }));
            } catch (error) {
                this.loadingNotificacoes = false;
                this.error.type = "API";
                this.error.message = error.response?.data?.mensagem || error.message || this.$t('RELHistoricoVeiculo.errorSearchingNotifications');
                this.error.status = error.response?.status || 500;
                this.$refs.erroDialog.showError();
                return [];
            }
        },
        getPositionType(position) {
            // Verificar flags para determinar o tipo da posição
            if (position.flag_notificacao_posicao_travada === 1 || position.flag_notificacao_posicao_invalida === 1) {
                return 'red'; // Inválida ou travada
            } else if (position.flag_atrasada === 1 || position.flag_fora_ordem === 1) {
                return 'yellow'; // Atrasada ou fora de ordem
            } else {
                return 'green'; // Posição OK
            }
        },
        getPositionTooltip(position, segmentStart) {
            const time = this.formatTime(segmentStart);
            const flags = [];
            
            if (position.flag_atrasada === 1) flags.push(this.$t('RELHistoricoVeiculo.timeline.flags.delayed'));
            if (position.flag_fora_ordem === 1) flags.push(this.$t('RELHistoricoVeiculo.timeline.flags.outOfOrder'));
            if (position.flag_notificacao_posicao_travada === 1) flags.push(this.$t('RELHistoricoVeiculo.timeline.flags.locked'));
            if (position.flag_notificacao_posicao_invalida === 1) flags.push(this.$t('RELHistoricoVeiculo.timeline.flags.invalid'));
            
            const flagText = flags.length > 0 ? ` (${flags.join(', ')})` : ` (${this.$t('RELHistoricoVeiculo.timeline.flags.ok')})`;
            return `${time} - ${this.$t('RELHistoricoVeiculo.speed')} ${position.velocidade} ${this.$t('RELHistoricoVeiculo.kmh')}${flagText}`;
        },
        formatTime(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleTimeString('pt-BR', { 
                hour: '2-digit', 
                minute: '2-digit',
                second: '2-digit'
            });
        },
        formatDuration(minutes) {
            if (minutes < 1) {
                return `${Math.round(minutes * 60)}s`;
            } else if (minutes < 60) {
                return `${Math.round(minutes)}min`;
            } else {
                const hours = Math.floor(minutes / 60);
                const mins = Math.round(minutes % 60);
                return `${hours}h ${mins}min`;
            }
        },
        onMapResize() {
            this.$refs.map.mapObject.invalidateSize();
        },
        onMapReady() {
            this.onMapResize();
        },
        latLng(lat, lng) {
            if (lat == null || lng == null) {
                return L.latLng(-22.88746, -43.29185);
            }
            return L.latLng(lat, lng);
        },
        closeMapDialog() {
            this.mapDialog = false;
        },
        plotar(item, tipo) {
            this.mapKey = this.mapKey === 0 ? 1 : 0;

            let tooltip = "";
            if (tipo == "Bilhetagem") {
                tooltip = item.dt_posicao_extenso;
            } else if (tipo == "Notificação") {
                tooltip = item.dt_notificacao_extenso;
            }

            this.marker = {
                lat: item.lat,
                lng: item.lng,
                tooltip: tooltip,
                type: tipo,
            };
            this.currentCenter = [item.lat, item.lng];
            this.zoom = 15;
            this.mapDialog = true;
        },
        openPlotagemViagem(item) {
            this.selectedViagem = {
                id_empresa: item.id_empresa,
                id_veiculo_realizado: item.id_veiculo_realizado,
                horario_saida_prevista: item.horario_saida_prevista || item.horario_saida_realizada,
                horario_chegada_prevista: item.horario_chegada_prevista || item.horario_chegada_realizada,
            };
            this.dialogPlotagemViagem = true;
            this.plotagemKey = this.plotagemKey === 0 ? 1 : 0;
        },
        closePlotagemViagem() {
            this.selectedViagem = {
                id_empresa: null,
                id_veiculo_realizado: null,
                horario_saida_prevista: null,
                horario_chegada_prevista: null,
            };
            this.dialogPlotagemViagem = false;
        },
        onSegmentClick(segment) {
            if (segment.hasPosition && segment.position) {
                // Plotar a posição no mapa
                this.plotar(segment.position, this.$t('RELHistoricoVeiculo.position'));
            }
        },
    },
};
</script>

<style scoped>
.timeline-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
}

.tabs-container {
    margin-top: 20px;
}

.timeline-wrapper {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.timeline-container-inner {
    margin-top: 20px;
}

.time-scale {
    position: relative;
    height: 40px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
}

.time-marker {
    position: absolute;
    top: 0;
    height: 100%;
}

.time-label {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    transform: translateX(-50%);
    margin-bottom: 5px;
}

.time-line {
    width: 1px;
    height: 20px;
    background-color: #ccc;
    margin: 0 auto;
}

.timeline-main {
    position: relative;
    height: 60px;
    background-color: #f8f9fa;
    border-radius: 4px;
    overflow: hidden;
}

.timeline-track {
    position: relative;
    height: 100%;
    width: 100%;
}

.timeline-segment {
    height: 100%;
    position: absolute;
    top: 0;
    cursor: pointer;
    transition: all 0.2s ease;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.timeline-segment:hover {
    opacity: 0.8;
    transform: scaleY(1.1);
}

.timeline-segment.has-position {
    cursor: pointer;
}

.timeline-segment.has-position:hover {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);
}

/* Cores dos segmentos */
.segment-green {
    background-color: #4caf50;
}

.segment-red {
    background-color: #f44336;
}

.segment-yellow {
    background-color: #ffeb3b;
}

.segment-gray {
    background-color: #9e9e9e;
}

.segment-missing {
    background-color: #ff9800;
}

.segment-empty {
    background-color: #e0e0e0;
}

.segment-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.segment-indicator {
    width: 4px;
    height: 4px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.3);
}

.timeline-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 4px;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.legend-color {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.legend-color.green {
    background-color: #4caf50;
}

.legend-color.red {
    background-color: #f44336;
}

.legend-color.yellow {
    background-color: #ffeb3b;
}

.legend-color.gray {
    background-color: #9e9e9e;
}
</style>